import { Link } from "@/components/link/link.component";

import { resolveLinkHref } from "@/utils/url.util";

import type { GetHomePageQueryResult } from "@/sanity.types";

export const AdtMonitoringBanner = ({
  block,
}: {
  block: MonitoringBannerBlock;
}) => {
  return (
    <section
      data-testid="adt-monitoring-banner"
      className="w-full overflow-hidden">
      <div className="flex h-[132px] items-center justify-center bg-white px-6 text-center sm:h-[148px]">
        <h2 className="headline-2 text-greyscale-headline">{block.title}</h2>
      </div>

      <div
        data-testid="adt-monitoring-media"
        className="sm:bg-greyscale-headline relative isolate flex w-full flex-col items-center overflow-hidden bg-white text-center sm:h-[600px] sm:justify-end sm:px-6 sm:py-12">
        <picture className="w-full sm:absolute sm:inset-0 sm:-z-20">
          <source
            media="(min-width: 640px)"
            srcSet={
              block.desktopImage?.url ?? block.mobileImage?.url ?? undefined
            }
          />
          <img
            src={block.mobileImage?.url ?? block.desktopImage?.url ?? ""}
            alt=""
            className="h-auto w-full object-cover sm:h-full"
          />
        </picture>
        <div
          aria-hidden
          className="absolute inset-0 -z-10 hidden bg-[linear-gradient(0deg,rgba(0,0,0,0.65)_0%,rgba(0,0,0,0.2)_55%,rgba(0,0,0,0)_100%)] sm:block"
        />

        <div className="w-full bg-white px-6 py-8 sm:max-w-5xl sm:bg-transparent sm:px-0 sm:py-0">
          <h3 className="headline-3 text-greyscale-headline sm:text-white">
            {block.message}
          </h3>
          {block.cta ? (
            <Link
              href={resolveLinkHref(block.cta.link)}
              border
              secondary
              className="border-adt-blue! text-adt-blue! hover:text-greyscale-headline! focus-visible:outline-blue mx-auto mt-8 w-fit px-8 py-3 hover:bg-white focus-visible:outline-2 focus-visible:outline-offset-4 sm:border-white! sm:text-white! sm:focus-visible:outline-white">
              {block.cta.label}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

type MonitoringBannerBlock = Extract<
  NonNullable<NonNullable<GetHomePageQueryResult>["pageBuilder"]>[number],
  { _type: "adtMonitoringBanner" }
>;
